import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ModalController, IonicModule } from "@ionic/angular";

@Component({
    selector: "app-reset-password",
    templateUrl: "./reset-password.component.html",
    styleUrls: ["./reset-password.component.scss"],
    standalone: true,
    imports: [
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
    ],
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm: FormGroup;
  currentPasswordType = "password";
  newPasswordType = "password";
  repeatPasswordType = "password";
  currentPasswordIcon = "eye-off";
  newPasswordIcon = "eye-off";
  repeatPasswordIcon = "eye-off";

  constructor(private fb: FormBuilder, private modalController: ModalController) {
    this.validateResetForm();
  }

  ngOnInit() { }

  onSubmit() { }

  validateResetForm() {
    this.resetPasswordForm = this.fb.group({
      currentPassword: [""],
      newPassword: [""],
      confirmPassword: [""],
    });
  }

  goBack() {
    this.modalController.dismiss().catch(err => { return err });
  }

  toggleViewPassword(type: string): void {

    if (type === "current") {
      this.currentPasswordType = this.currentPasswordType === "text" ? "password" : "text";
      this.currentPasswordIcon = this.currentPasswordIcon === "eye" ? "eye-off" : "eye";
    } else if (type === "new") {
      this.newPasswordType = this.newPasswordType === "text" ? "password" : "text";
      this.newPasswordIcon = this.newPasswordIcon === "eye" ? "eye-off" : "eye";
    } else if (type === "repeat") {
      this.repeatPasswordType = this.repeatPasswordType === "text" ? "password" : "text";
      this.repeatPasswordIcon = this.repeatPasswordIcon === "eye" ? "eye-off" : "eye";
    }
  }
}
